import { matchPath } from 'react-router';
import { LOCATION_CHANGE, LocationChangeAction } from 'connected-react-router';
import isEqual from 'lodash/isEqual';
import { SCOPE_CATALOGUE_OBJECT } from './actions';
import { SearchState } from './state';
import {
    SEARCH_QUERY_SELECTED_TOPHIT,
    SEARCH_RESET,
    SEARCH_SCOPE_CHANGE,
    SEARCH_SUGGESTIONS,
    SEARCH_SUGGESTIONS_RESET,
    SearchAction
} from './types';
import { deriveSearchScopeFromPathname } from '../../shared/search/utils/deriveSearchScopeFromPathname';

const initialSearchState = { scope: SCOPE_CATALOGUE_OBJECT };

export function searchReducer(
    state: SearchState = initialSearchState,
    action: SearchAction | LocationChangeAction
): SearchState {
    let newSearchState = state;
    switch (action.type) {
        case SEARCH_RESET: {
            newSearchState = { scope: state.scope };
            break;
        }
        case SEARCH_SUGGESTIONS: {
            const searchSuggestion = action.payload;

            newSearchState = {
                ...state,
                suggestions: searchSuggestion.data?.suggestions ?? {},
                topHits: searchSuggestion.data?.topHits ?? []
            };
            break;
        }
        case SEARCH_SCOPE_CHANGE: {
            const scope = action.payload;
            newSearchState = { ...state, scope: scope };
            break;
        }
        case SEARCH_SUGGESTIONS_RESET: {
            newSearchState = { ...state, suggestions: undefined, topHits: [] };
            break;
        }
        case SEARCH_QUERY_SELECTED_TOPHIT: {
            const topHitLabel = action.payload;
            newSearchState = { ...state, topHitLabel: topHitLabel };
            break;
        }
        case LOCATION_CHANGE:
            return reduceLocationChange(state, action);
        default:
            break;
    }

    return newSearchState;
}

function reduceLocationChange(state: SearchState, action: LocationChangeAction): SearchState {
    const pathname = action.payload.location.pathname;

    const searchMatch = matchPath(pathname, { path: '/search' });
    if (searchMatch) {
        return state;
    }

    const newSearchScope = deriveSearchScopeFromPathname(pathname);

    if (isEqual(newSearchScope, state.scope)) {
        return state;
    }

    return {
        ...state,
        scope: newSearchScope
    };
}
